import * as React from "react";
import type { SVGProps } from "react";
const SvgInflatableFlamingo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.46 11.31A9.37 9.37 0 0 1 13.895 15H5.24A3.24 3.24 0 0 0 2 18.24v.52A3.24 3.24 0 0 0 5.24 22h13.52A3.24 3.24 0 0 0 22 18.76v-.52c0-.052-.001-.103-.004-.154A.977.977 0 0 0 22 18c0-3-2.21-5.77-3.82-7.76a21.416 21.416 0 0 1-1.33-1.76c-.12-.21-.06-.32-.06-.32a.9.9 0 0 1 .75-.29 1.3 1.3 0 0 1 .93.5c.311.34.476.79.46 1.25a1 1 0 0 0 1.84.66A9.07 9.07 0 0 0 22 6c0-1.38-1.25-4-6-4a4.7 4.7 0 0 0-5 5 8.87 8.87 0 0 0 1.46 4.31Zm4.16.18c.857 1.056 1.831 2.26 2.512 3.531A3.224 3.224 0 0 0 18.76 15h-2.842a11.12 11.12 0 0 0-1.708-4.65A7.2 7.2 0 0 1 13 7a2.72 2.72 0 0 1 3-3c.491 0 .925.032 1.307.089a4.999 4.999 0 0 0-.747 1.904A2.824 2.824 0 0 0 15 7.19a2.25 2.25 0 0 0 .15 2.3c.45.695.941 1.363 1.47 2Zm1.963-5.419A3.198 3.198 0 0 1 19.9 7c.065-.33.098-.664.1-1 0-.274-.172-.757-.73-1.18a3.12 3.12 0 0 0-.687 1.251ZM5.24 17A1.23 1.23 0 0 0 4 18.24v.52A1.23 1.23 0 0 0 5.24 20h13.52A1.23 1.23 0 0 0 20 18.76v-.52A1.23 1.23 0 0 0 18.76 17H5.24Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInflatableFlamingo;
